// Level element      Character  ASCII Code
// Wall                  #         0x23
// Player                @         0x40
// Player on goal square +         0x2b
// Box                   $         0x24
// Box on goal square    *         0x2a
// Goal square           .         0x2e
// Floor              (Space)      0x20

const LEVELS = [
  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", " ", " ", ".", " ", "#"],
  ["#", "#", " ", "*", " ", "#", " ", "#"],
  ["#", "#", " ", ".", "$", " ", " ", "#"],
  ["#", "#", " ", " ", "#", "$", "#", "#"],
  ["#", "#", "#", " ", "@", " ", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", " ", ".", "@", " ", "#"],
  ["#", "#", " ", "#", ".", "#", " ", "#"],
  ["#", "#", " ", " ", " ", "$", " ", "#"],
  ["#", "#", ".", "$", "$", " ", "#", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", " ", "@", "#", "#"],
  ["#", " ", " ", "*", "$", " ", "#", "#"],
  ["#", " ", " ", " ", " ", " ", "#", "#"],
  ["#", "#", " ", ".", "#", "#", "#", "#"],
  ["#", "#", "$", " ", "#", "#", "#", "#"],
  ["#", "#", " ", ".", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", ".", "#", "#", "#", ".", "#"],
  ["#", "#", " ", "#", " ", " ", ".", "#"],
  ["#", "#", " ", "$", "$", " ", "@", "#"],
  ["#", "#", " ", " ", "$", " ", " ", "#"],
  ["#", "#", " ", " ", "#", " ", " ", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", " ", "@", "#", "#"],
  ["#", "#", "#", "#", " ", " ", " ", "#"],
  ["#", ".", " ", "#", "$", "$", " ", "#"],
  ["#", " ", " ", " ", " ", " ", "#", "#"],
  ["#", ".", " ", " ", "$", "#", "#", "#"],
  ["#", "#", ".", " ", " ", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", " ", ".", ".", "#", "#", "#", "#"],
  ["#", " ", "$", " ", " ", " ", " ", "#"],
  ["#", " ", " ", "#", "$", "#", " ", "#"],
  ["#", " ", "@", " ", ".", "$", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", " ", " ", ".", "#", "#"],
  ["#", " ", "$", " ", "#", " ", "#", "#"],
  ["#", " ", "*", "$", " ", " ", "#", "#"],
  ["#", " ", ".", "#", "@", " ", "#", "#"],
  ["#", " ", " ", " ", " ", "#", "#", "#"],
  ["#", " ", " ", " ", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", ".", " ", " ", "@", ".", "#", "#"],
  ["#", " ", " ", "$", "#", " ", "#", "#"],
  ["#", " ", "#", " ", "$", ".", " ", "#"],
  ["#", " ", " ", " ", "$", "#", " ", "#"],
  ["#", "#", "#", "#", " ", " ", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", ".", " ", ".", "#", "#", "#", "#"],
  ["#", ".", "#", "$", "$", " ", "#", "#"],
  ["#", " ", " ", " ", "@", " ", "#", "#"],
  ["#", " ", "$", "#", " ", " ", "#", "#"],
  ["#", "#", " ", " ", " ", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", ".", " ", " ", "#", "#", "#", "#"],
  ["#", " ", "#", " ", " ", " ", "#", "#"],
  ["#", " ", ".", " ", "#", " ", "#", "#"],
  ["#", " ", "$", "*", "$", " ", "#", "#"],
  ["#", "#", "@", " ", "#", "#", "#", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", ".", " ", " ", " ", ".", " ", "#"],
  ["#", " ", "#", " ", "#", " ", " ", "#"],
  ["#", "@", "$", " ", " ", "$", ".", "#"],
  ["#", "#", "#", "#", "#", " ", "$", "#"],
  ["#", "#", "#", "#", "#", " ", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", " ", " ", "#", "#", "#", "#", "#"],
  ["#", " ", " ", "#", "#", "#", "#", "#"],
  ["#", " ", ".", "*", " ", " ", " ", "#"],
  ["#", "#", "$", " ", " ", " ", " ", "#"],
  ["#", "#", " ", "#", "$", "#", "#", "#"],
  ["#", "#", ".", " ", "@", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", "@", " ", "#", "#", "#"],
  ["#", "#", " ", ".", " ", " ", " ", "#"],
  ["#", ".", " ", "$", ".", "$", " ", "#"],
  ["#", "#", "$", "#", " ", "#", "#", "#"],
  ["#", "#", " ", " ", " ", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", " ", " ", "#", "#", "#"],
  ["#", " ", "$", "#", " ", "#", "#", "#"],
  ["#", " ", ".", " ", "@", "#", "#", "#"],
  ["#", " ", "*", " ", " ", " ", "#", "#"],
  ["#", "#", " ", "#", "$", " ", "#", "#"],
  ["#", "#", ".", " ", " ", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", ".", ".", "$", " ", " ", ".", "#"],
  ["#", " ", "#", "$", " ", "$", " ", "#"],
  ["#", "@", " ", " ", "#", " ", " ", "#"],
  ["#", "#", "#", "#", "#", " ", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", " ", ".", "@", "#", "#"],
  ["#", "#", " ", " ", " ", "$", ".", "#"],
  ["#", "#", "#", "#", "*", "#", " ", "#"],
  ["#", "#", " ", " ", " ", " ", " ", "#"],
  ["#", " ", " ", "$", " ", " ", "#", "#"],
  ["#", " ", " ", " ", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "@", " ", "#", "#", "#", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", "#", ".", " ", "#", "#", "#", "#"],
  ["#", " ", "$", "$", ".", " ", ".", "#"],
  ["#", " ", " ", "$", " ", "#", "#", "#"],
  ["#", "#", "#", " ", " ", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", ".", " ", " ", "#", "#", "#"],
  ["#", "#", " ", "#", " ", "#", "#", "#"],
  ["#", "#", " ", "*", "$", " ", " ", "#"],
  ["#", "#", " ", " ", "$", ".", " ", "#"],
  ["#", "#", " ", " ", "@", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", " ", " ", " ", "#", "#"],
  ["#", "#", "#", " ", "#", ".", "#", "#"],
  ["#", "#", "#", " ", " ", ".", "#", "#"],
  ["#", "@", " ", "$", "$", " ", "#", "#"],
  ["#", " ", " ", ".", "$", " ", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", " ", " ", " ", "@", "#", "#", "#"],
  ["#", " ", "$", "#", " ", "#", "#", "#"],
  ["#", " ", "*", " ", "$", " ", " ", "#"],
  ["#", " ", " ", " ", "#", "#", " ", "#"],
  ["#", "#", ".", " ", " ", ".", " ", "#"],
  ["#", "#", "#", " ", " ", " ", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", " ", " ", "@", "#", "#"],
  ["#", "#", " ", " ", "#", " ", " ", "#"],
  ["#", "#", ".", " ", " ", "$", " ", "#"],
  ["#", "#", " ", "$", "$", "#", ".", "#"],
  ["#", "#", "#", "#", " ", " ", ".", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", ".", " ", "#", "#", "#"],
  ["#", " ", ".", " ", " ", "#", "#", "#"],
  ["#", " ", " ", " ", "$", "$", " ", "#"],
  ["#", "#", " ", ".", " ", "$", "@", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "@", ".", " ", " ", "#", "#"],
  ["#", " ", "$", "$", "*", " ", "#", "#"],
  ["#", " ", " ", "#", " ", " ", "#", "#"],
  ["#", " ", " ", "#", " ", " ", ".", "#"],
  ["#", "#", "#", "#", " ", "#", " ", "#"],
  ["#", "#", "#", "#", " ", " ", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", " ", " ", "#"],
  ["#", "#", "#", "#", "#", "$", ".", "#"],
  ["#", "#", "#", " ", " ", ".", " ", "#"],
  ["#", "#", "#", " ", " ", "#", ".", "#"],
  ["#", " ", "$", " ", " ", "$", " ", "#"],
  ["#", " ", " ", " ", "#", "@", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", " ", " ", "#", "#", "#"],
  ["#", "#", "#", " ", " ", "#", "#", "#"],
  ["#", "#", "#", " ", ".", ".", " ", "#"],
  ["#", " ", " ", "$", "#", " ", " ", "#"],
  ["#", " ", " ", ".", "$", "$", " ", "#"],
  ["#", "#", "#", "#", " ", "@", " ", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", " ", " ", " ", "#", "#", "#", "#"],
  ["#", " ", "#", " ", "*", "@", "#", "#"],
  ["#", " ", " ", "*", " ", " ", " ", "#"],
  ["#", "#", "#", "$", " ", " ", " ", "#"],
  ["#", "#", "#", " ", " ", " ", ".", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", " ", ".", " ", " ", "#"],
  ["#", " ", "$", "@", "#", ".", " ", "#"],
  ["#", " ", " ", "$", "#", " ", "#", "#"],
  ["#", " ", " ", "*", " ", " ", "#", "#"],
  ["#", "#", " ", " ", "#", " ", "#", "#"],
  ["#", "#", "#", " ", " ", " ", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", " ", " ", " ", " ", " ", "#", "#"],
  ["#", " ", " ", "#", "$", "$", "@", "#"],
  ["#", " ", " ", ".", " ", "*", ".", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "@", " ", " ", " ", " ", "#"],
  ["#", ".", " ", "#", " ", " ", " ", "#"],
  ["#", " ", "$", "$", "$", ".", "#", "#"],
  ["#", " ", ".", "#", " ", " ", "#", "#"],
  ["#", " ", " ", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]],

  [["#", "#", "#", "#", "#", "#", "#", "#"],
  ["#", " ", " ", ".", "#", "#", "#", "#"],
  ["#", " ", "$", ".", ".", " ", "#", "#"],
  ["#", " ", " ", "#", "#", "$", "#", "#"],
  ["#", "#", " ", " ", "#", " ", " ", "#"],
  ["#", "#", "$", " ", " ", " ", "@", "#"],
  ["#", "#", " ", " ", "#", "#", "#", "#"],
  ["#", "#", "#", "#", "#", "#", "#", "#"]]
];

console.log(LEVELS.length);

export default LEVELS;



//////////////////
// WEBPACK FOOTER
// ./lib/levels.js
// module id = 3
// module chunks = 0